import React, {Component} from 'react';
import Header from '../decoration/header';
import SearchBar from '../decoration/searchBar';
import Footer from '../footer/footer';

import '../catagory/catagory.css';
import './singleCategory.css';

const searchBarStyle = {
  width: '100%',
  display: "flex",
  justifyContent: "center",
}

class SingleCategory extends Component {
	state = {
		hideCaption: false
	}

	componentDidMount() {
		switch (this.props.match.params.catename) {
			case 'CONGRATULATIONS':
			case 'HAMPER | FRUITS':
			case 'ORCHID':
			case 'SYMPATHY':
			case 'ARRANGEMENT WITH VASE':
			this.setState({hideCaption: true})
			break;
			default:break;
		}
	}


  	render() {
			// Update 19/8/2021: Currently top message only show in the mid autumn festival 2021
			const showTopMessage = window.location.pathname.indexOf('*Mid-Autumn-Festival-2021') > -1;
  		return(
  			<div>
			    <Header showTopMessage={showTopMessage} />
			    <div className="SingleCategory">
				    {!this.state.hideCaption && <div id='catagoryPanelCaption'><h1>OUR SHOP</h1></div>}
				    <div className='shopContainer'>
					    <SearchBar catename={this.props.match.params.catename} searchBarStyle={searchBarStyle} />
				    </div>
			    </div>
			    <Footer />
		    </div>

	  	);
  	}
}

export default SingleCategory;



// WEBPACK FOOTER //
// ./src/components/singleCategory/singleCategory.js